<template>
<div :class="$style['handle']">
    <pt-sub-title title="确认已处置">
    </pt-sub-title>
    <pt-form-item label="处置方法：" :labelWidth="labelWidth" :required="true">
      <wt-selector :options="options" name="reason" data-vv-as="处置方法" v-validate="'required'" v-model="form.handleMethod" :clearable="true" :allow-create="true" :filterable="true" @mousedown.stop.native @click.stop.native :props="reasonProps" :noDataText="'暂无选项，请您直接录入内容'"></wt-selector>
    </pt-form-item>
    <pt-form-item label="归还方式：" :labelWidth="labelWidth" :required="true">
      <wt-selector :options="options" name="reason" data-vv-as="归还方式" v-validate="'required'" v-model="form.backType" :clearable="true" :allow-create="true" :filterable="true" @mousedown.stop.native @click.stop.native :props="reasonProps" :noDataText="'暂无选项，请您直接录入内容'"></wt-selector>
    </pt-form-item>
    <pt-form-item label="快递单号：" :labelWidth="labelWidth">
      <array-input v-model="form.expressIds" placeholder="请输入检快递单号"></array-input>
    </pt-form-item>
</div>
</template>
<script>
import {
  validate
} from 'utils/validate'
import arrayInput from 'cps/common/array-input'

export default {
  name: 'delay-dialog',
  props: {
  },
  components:{
    arrayInput
  },
  data () {
    return {
      labelWidth:'100px',
      form:{
        expressIds:[{ value: '' }],
      },
      options:[],
      reasonProps: {
        label: 'name',
        value: 'id'
      },
    }
  },
  watch: {
   
  },
  methods: {
    formValidata () {
      return validate(this, this.form)
    }   
  }
}
</script>
<style module lang="less">
@import "~less/var";
.handle {
  :global {
    .el-input,
    .el-input__inner {
      max-width: 2.8rem;
    }
    .el-input--suffix .el-input__inner {
      min-width: 2.8rem;
    }
    
  }
}
</style>
